module.exports = __webpack_public_path__ + "img/imgNone.547ce793.svg";